import { api } from './api';

interface UnknownObject {
  [key: string]: unknown;
}

export interface FollowingCreator {
  id: string;
  displayName: string;
  profilePictureUrl: string | null;
  headline: string;
  sharedProfileUrl: string;
  availabilityNotificationsEnabled: boolean;
}

export interface FollowingResponse {
  professionals: FollowingCreator[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export const getFollowing = async (
  pageNumber: number,
  pageSize: number
): Promise<FollowingResponse> => {
  try {
    const response = await api.get('/v1/user/following', {
      params: {
        pageNumber,
        pageSize,
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching following creators:', error);
    throw error;
  }
};

export const followCreator = async (professionalId: string): Promise<void> => {
  try {
    await api.post(`/v1/user/follow/${professionalId}`);
  } catch (error) {
    console.error('Error following creator:', error);
    throw error;
  }
};

export const unfollowCreator = async (
  professionalId: string
): Promise<void> => {
  try {
    await api.post(`/v1/user/unfollow/${professionalId}`);
  } catch (error) {
    console.error('Error unfollowing creator:', error);
    throw error;
  }
};

export const toggleAvailabilityNotifications = async (
  professionalId: string,
  enabled: boolean
): Promise<void> => {
  try {
    await api.post(
      `/v1/notification/availability-notifications/${professionalId}/toggle`,
      {},
      {
        params: {
          enabled,
        },
      }
    );
  } catch (error) {
    console.error('Error toggling availability notifications:', error);
    throw error;
  }
};
